const NumberMap = new Map();

NumberMap.set('success', 1);
NumberMap.set('secondary', 0);

export default NumberMap;
